'use client';

import MagicJump from '@/components/MagicJump';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { useReporting } from '@/hooks/useReporting';
import { ProviderType } from '@/reporting/types';
import logger from '@/utils/client-logger';
import { EPlatform } from '@/utils/enums/platform-enum';
import Image from '@/components/Image';
import { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

interface BannerProps {
  pageData: any;
  sDPageExp?: (
    mkt_name: string,
    pits_index: number,
    pits_jump_type?: string,
    pits_jump_content?: string,
  ) => void;
}

export default function Banner({ pageData, sDPageExp }: BannerProps) {
  const { deviceType } = useContext(ResponsiveContext);

  // ✅ 使用新的埋点系统
  const { trackEvent } = useReporting();

  // 曝光埋点 - 使用useInView来检测元素是否进入视口
  const [expRef, inView] = useInView({
    threshold: 0.8, // 80%的元素进入视口时触发
    triggerOnce: true, // 只触发一次
  });

  // 处理曝光埋点
  useEffect(() => {
    if (inView && sDPageExp) {
      // 调用父组件传入的曝光方法
      sDPageExp(
        '顶部banner',
        0,
        pageData?.jump_target?.jump_type?.toString(),
        pageData?.jump_target?.Jump_target,
      );
    }
  }, [inView, sDPageExp, pageData]);

  const handleTrackingClick = (
    mkt_name: string,
    pits_index: number,
    pits_jump_type?: string,
    pits_jump_content?: string,
  ) => {
    try {
      const trackingData = {
        mkt_name,
        pits_index,
        pits_jump_type,
        pits_jump_content,
      };

      trackEvent(
        {
          eventName: 'AmbassadorHomePageMkt_Click',
          properties: trackingData,
        },
        [ProviderType.SENSORS],
      );
    } catch (error) {
      logger.error('AmbassadorHomePageMkt_Click tracking error:', error);
    }
  };

  return (
    <div
      ref={expRef}
      className="ambassador-banner relative flex items-center justify-center text-center"
    >
      <MagicJump
        item={pageData.jump_target || { jump_type: 0, Jump_target: '' }}
        onBeforeJump={() =>
          handleTrackingClick(
            '顶部banner',
            0,
            pageData.jump_target?.jump_type?.toString(),
            pageData.jump_target?.Jump_target,
          )
        }
        style={{
          width: '100%',
          height: 'auto',
        }}
      >
        <Image
          className="w-[100%] h-[auto]"
          src={pageData.image || '/static/images/default-banner.jpg'}
          alt={pageData.title || 'ZEELOOL Ambassador'}
          width={deviceType !== EPlatform.WEB ? 375 : 1920}
          height={deviceType !== EPlatform.WEB ? 372 : 592}
          priority
          style={{
            minHeight: deviceType !== EPlatform.WEB ? '372px' : '592px',
            objectFit: 'cover',
          }}
        />
      </MagicJump>
    </div>
  );
}
